import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD = '[Marketplace.OnFleet Operator Collection] Load';
export const LOAD_SUCCESS = '[Marketplace.OnFleet Operator Collection] Load Success';
export const LOAD_FAIL = '[Marketplace.OnFleet Operator Collection] Load Fail';

export class LoadActionPayload {
    dedicatedFleet: boolean; 
}

export class LoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: LoadActionPayload) {}
}

export class LoadSuccessAction implements Action {
  readonly type = LOAD_SUCCESS;

  constructor(public payload: Array<models.Operator>) {}
}

export class LoadFailAction implements Action {
  readonly type = LOAD_FAIL;
}

export type Actions = LoadAction | LoadSuccessAction | LoadFailAction;
